import { render, staticRenderFns } from "./ManageClass.vue?vue&type=template&id=55a725a4"
import script from "./ManageClass.vue?vue&type=script&lang=js"
export * from "./ManageClass.vue?vue&type=script&lang=js"
import style0 from "./ManageClass.vue?vue&type=style&index=0&id=55a725a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports